webpackJsonp([70144966829960],{

/***/ "./assets/paper-plane.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/paper-plane.5da0675d.png";

/***/ }),

/***/ "./src/components/ContactForm.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  ", ";\n"], ["\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    font-size: 2rem;\n  "], ["\n    font-size: 2rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n  width: 100%;\n  max-width: 40rem;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n  width: 100%;\n  max-width: 40rem;\n  align-items: stretch;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  border: 2px solid ", ";\n  display: flex;\n  height: 9rem;\n  ", ";\n"], ["\n  border: 2px solid ", ";\n  display: flex;\n  height: 9rem;\n  ", ";\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  border: 2px solid ", ";\n  flex-grow: 11;\n  line-height: 2;\n  margin-right: 0rem;\n  margin-bottom: .7rem;\n  ", ";\n  @media (min-width: 700px) {\n    + input {\n      margin-left: 1rem;\n    }\n  }\n"], ["\n  border: 2px solid ", ";\n  flex-grow: 11;\n  line-height: 2;\n  margin-right: 0rem;\n  margin-bottom: .7rem;\n  ", ";\n  @media (min-width: 700px) {\n    + input {\n      margin-left: 1rem;\n    }\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  border-radius: 4px;\n  border: none;\n  background-color: ", ";\n\n  ", ";\n"], ["\n  flex-grow: 1;\n  border-radius: 4px;\n  border: none;\n  background-color: ", ";\n\n  ", ";\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n    margin-left: 0;\n    margin-top: 2rem;\n  "], ["\n    margin-left: 0;\n    margin-top: 2rem;\n  "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding-top: 2rem;\n  width: 100%;\n  max-width: 40rem;\n\n  ", ";\n"], ["\n  display: flex;\n  padding-top: 2rem;\n  width: 100%;\n  max-width: 40rem;\n\n  ", ";\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n    flex-direction: column;\n    padding-top: 0rem;\n  "], ["\n    flex-direction: column;\n    padding-top: 0rem;\n  "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  height: 2rem;\n  width: 2rem;\n  padding: .5rem;\n"], ["\n  height: 2rem;\n  width: 2rem;\n  padding: .5rem;\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["padding-top: 3rem;"], ["padding-top: 3rem;"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n  justify-content: center;\n  font-weight: 600;\n"], ["\n  justify-content: center;\n  font-weight: 600;\n"]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n  justify-content: center;\n  text-align: center;\n  padding: 1rem;\n  font-size: 1rem;\n"], ["\n  justify-content: center;\n  text-align: center;\n  padding: 1rem;\n  font-size: 1rem;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _paperPlane = __webpack_require__("./assets/paper-plane.png");
	
	var _paperPlane2 = _interopRequireDefault(_paperPlane);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContactForm = _styledComponents2.default.div(_templateObject);
	
	var Title = _typography.H1.extend(_templateObject2, function (props) {
	  return props.theme.media.mobile(_templateObject3);
	});
	
	var Form = _styledComponents2.default.form(_templateObject4);
	
	var inputStyle = "\n  flex: 1;\n  border-radius: 4px;\n  resize: none;\n  ::-webkit-input-placeholder {\n    color: " + (0, _utils.getThemeColor)("grey") + ";\n  }\n  max-width: 40rem;\n  padding: 1rem;\n";
	
	var TextArea = _styledComponents2.default.textarea(_templateObject5, (0, _utils.getThemeColor)("greyAccent"), inputStyle);
	
	var Input = _styledComponents2.default.input(_templateObject6, (0, _utils.getThemeColor)("greyAccent"), inputStyle);
	
	var SubmitButton = _styledComponents2.default.button(_templateObject7, (0, _utils.getThemeColor)("teal"), function (props) {
	  return props.theme.media.mobile(_templateObject8);
	});
	
	var EmailAndSubmit = _styledComponents2.default.div(_templateObject9, function (props) {
	  return props.theme.media.mobile(_templateObject10);
	});
	
	var Image = _styledComponents2.default.img(_templateObject11);
	
	var FullAddress = _styledComponents2.default.div(_templateObject12);
	
	var City = _typography.H5.extend(_templateObject13);
	
	var Address = _typography.P.extend(_templateObject14);
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      address = _ref.address;
	  return _react2.default.createElement(
	    ContactForm,
	    null,
	    _react2.default.createElement(_Pad2.default, { v: 2 }),
	    _react2.default.createElement(
	      Title,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      Form,
	      {
	        method: "POST",
	        action: "https://q6uiyos8bl.execute-api.us-east-1.amazonaws.com/prod"
	      },
	      _react2.default.createElement(
	        _Flex.HFlexFlipper,
	        { align: "stretch" },
	        _react2.default.createElement(Input, { placeholder: "Name", name: "name", id: "name" }),
	        _react2.default.createElement(Input, { placeholder: "Email", name: "email", id: "email" })
	      ),
	      _react2.default.createElement(TextArea, { placeholder: "Message", rows: 4, name: "message", id: "message" }),
	      _react2.default.createElement(
	        EmailAndSubmit,
	        null,
	        _react2.default.createElement(
	          SubmitButton,
	          { type: "submit" },
	          _react2.default.createElement(Image, { src: _paperPlane2.default })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      FullAddress,
	      null,
	      _react2.default.createElement(
	        City,
	        null,
	        "Address"
	      ),
	      _react2.default.createElement(
	        Address,
	        null,
	        (address || "").split("|").map(function (a) {
	          return _react2.default.createElement(
	            "div",
	            null,
	            a
	          );
	        })
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/opt/build/repo/node_modules/babel-preset-react-app/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/react-hot-loader/babel.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ContactForm = __webpack_require__("./src/components/ContactForm.js");
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var content = (0, _selectors.getGraphNode)(data, "ContactPage");
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: "Contraline Contact",
	        meta: [{ name: "Contraline", content: "Contact" }]
	      },
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	    ),
	    _react2.default.createElement(_NavBar2.default, { color: "dark" }),
	    _react2.default.createElement(
	      _Section2.default,
	      null,
	      _react2.default.createElement(_ContactForm2.default, { title: content.title, address: content.address })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-376b79a18bdda4635338.js